import React, {FC} from 'react';

import {Link} from 'react-router-dom';

import Logo from '../../assets/Logo2.png'
import footerStyles from '../../styles/Home/Footer';
import { Grid, Box } from '@material-ui/core';


const Footer: FC = () => {
    const classes = footerStyles();
    return(
        <Grid container className={classes.footerContainer}>
            <Grid item xs={12} sm={4}  md={4}>
                <div className={classes.menuInfoContainer}>
                    <h3>
                        La cava de don Carlos
                    </h3>
                    <Link to='/' className='text-normalize'><span>Home</span></Link>
                    <Link to='/' className='text-normalize'><span>Shop</span></Link>
                    <Link to='/' className='text-normalize'><span>About</span></Link>
                </div>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                <Box className={classes.contactContainer} p={2}>
                        <h3>Contacto</h3>
                        <span>Sucursal Morelia</span>
                        <span>Lunes-Viernes</span>
                        <span>10:00 am - 6:00 pm</span>
                </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                    <div className={classes.logoContainer}>
                        <img src={Logo} alt="Cava de don Carlos" className={classes.logo}/>
                    </div>
            </Grid>
        </Grid>          
    )
}

export default Footer;